import React, { memo } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SpaceAgentsSidebarSkeleton } from './SpaceAgentsSidebarSkeleton.tsx';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebars-content-space-agents" */ './SpaceAgentsSidebar.tsx'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const AsyncSpaceAgentsSidebarComponent = (): React.JSX.Element => (
	<UFOSegment name="space-agents-sidebar">
		<SidebarBoundary
			id="space-agents.sidebar"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentSpaceAgents"
			ufoName="space-agents.sidebar"
		>
			<Placeholder name="space-agents.sidebar" fallback={<SpaceAgentsSidebarSkeleton />}>
				<LazySidebarContent />
			</Placeholder>
		</SidebarBoundary>
	</UFOSegment>
);

const AsyncSpaceAgentsSidebar: React.MemoExoticComponent<() => React.JSX.Element> = memo(
	AsyncSpaceAgentsSidebarComponent,
);
export default AsyncSpaceAgentsSidebar;
